import { Component, Input, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { KEY_CONFIG } from '../../config/key-config';
import { UtilityService } from '../../providers/utility.service';

@Component({
  selector: 'app-modal',
  styleUrls: ['./modal-popup.component.scss'],
  templateUrl: './modal-popup.component.html'
})

export class ModalPopupComponent implements OnInit {
  
  @Input() showModal: boolean;

  @Input() modalClass: string;
  @Input() triggerElement: any;
  @Input() modalCoverClass: string;
  @Output()
  modalOutput: EventEmitter<boolean>;
  public focusAbleElements: any;

  constructor(private util: UtilityService, private el: ElementRef) {
      this.modalOutput = new EventEmitter<boolean>();
      this.showModal = false;
  }

  ngOnInit() {

  }

  loadFocusTelements() {
    if (!this.focusAbleElements) {
      const focusAbleEls = this.util.getFocusableElements(this.el);
      this.focusAbleElements = Array.prototype.slice.call(focusAbleEls);
      if(document.getElementById('modalHeading') != null){
        document.getElementById('modalHeading').focus();
      }    
    }
  }

  handleKeydown(event) {
    if(event.keyCode === KEY_CONFIG.enter && event.target.id === 'device-lock-btn'){
         event.stopPropagation();
         return;
    }
    if(event.keyCode === KEY_CONFIG.enter ||event.keyCode === KEY_CONFIG.escapeKey) {
      this.modalOutput.emit(false);
      this.focusAbleElements = undefined;
      if (this.triggerElement) {
              this.triggerElement.focus();
            }
            event.preventDefault();
            event.stopPropagation();
      return;
    }
    this.util.handleKeyPress(event, this.focusAbleElements);
  }

  
  /*
    @Input() showModal: boolean;
  
    @Input() modalMessage: string;
  
    @Input() modalSubHeader: string;
  
    @Input() modalHeader: string;
    @Input() triggerElement: any;
  
    @Output()
    modalOutput: EventEmitter<boolean>;
  
    focusabbleElements: any;
  
    constructor(protected router: Router, private el: ElementRef) {
      console.log('modal constructor');
      this.modalOutput = new EventEmitter<boolean>();
      this.showModal = false;
    }
  
     btnAction(value) {
       if (value === 'yes') {
         this.showModal = true;
       }else {
         this.showModal = false;
       }
       this.focusabbleElements = undefined;
       if(this.triggerElement){
         this.triggerElement.focus();
       }
       this.modalOutput.emit(this.showModal);
    }
  
    ngOnInit() {
      console.log( 'modal init' );
    }
  
    ngAfterViewInit(){
      console.log('onload');
    }
  
    loadFocustelements(){
       if (!this.focusabbleElements) {
          let focusableEls = this.el.nativeElement.
          querySelectorAll('a[href], area[href],' +
          ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
          this.focusabbleElements = Array.prototype.slice.call(focusableEls);
          this.focusabbleElements[0].focus();
    }
    }
  
    handleKeydown(event) {
      let focussedEl = event.target;
      if(event.keyCode === ESCAPE_KEY) {
        this.btnAction('no');
        return;
      }
      if (event.keyCode === TAB_KEY_CODE) {
          if (focussedEl === this.focusabbleElements[this.focusabbleElements.length - 1 ]) {
          event.preventDefault();
          this.focusabbleElements[0].focus();
        }
      }
    }
  */

}
